export const GenderEnum = Object.freeze({
  Male: 10,
  Female: 20,
});

export const getGenderKey = (value) => {
  return Object.keys(GenderEnum).find(key => GenderEnum[key] === value);
};